import { __assign, __rest } from "tslib";
import React from 'react';
import noImagePreviewSvg from '../assets/no-image-preview.svg?url';
import { FallbackImg } from '../Img';
import Thumbnail from './Thumbnail';
var ImagePlaceholder = function (props) { return (React.createElement("img", __assign({ "data-hook": "image-placeholder", src: noImagePreviewSvg, style: { width: 61, height: 75 } }, props))); };
var ImageThumbnail = function (_a) {
    var className = _a.className, src = _a.src, props = __rest(_a, ["className", "src"]);
    return (React.createElement(Thumbnail, __assign({}, props),
        React.createElement(FallbackImg, { label: props.label, src: src, className: className, placeholder: React.createElement(ImagePlaceholder, { alt: props.label }) }),
        props.children));
};
export default ImageThumbnail;
//# sourceMappingURL=ImageThumbnail.js.map